<template>
  <a-result status="403" title="无权访问该站点" sub-title="您的账号不属于该地区">
    <template #extra>
      <a-button type="primary" @click="goBack">返回登录</a-button>
      <a-button type="primary" @click="redirect">访问所属站点</a-button>
    </template>
  </a-result>
</template>

<script>
export default {
  name: "Limit",
  data() {
    return {
      hostName:""
    }
  },
  methods:{
    goBack(){
      this.$router.push("/login");
    },
    redirect(){

      window.location.href=`http://${this.hostName}`;
    }
  },
  mounted() {

    this.hostName=this.$route.params.hostName;
  }
}
</script>

<style scoped>

</style>